<template>
  <div id="error">
    <div class="page">
      <div class="form" :class="$mq">
        <h1>{{ $t('NotFound.title') }}</h1>
        <h2 class="error">{{ $t('NotFound.error') }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.form .error {
  text-align: left;
  font-size: 0.8rem;
  padding: 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/NotFound.vue